import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { InvoiceService } from 'src/app/services/invoice_service.service';
import { MatButton } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@Component({
    selector: 'app-update-invoice-dialog',
    templateUrl: './update-invoice-dialog.component.html',
    styleUrls: ['./update-invoice-dialog.component.scss'],
    imports: [MatDialogActions, MatButton, MatDialogClose, MatProgressBarModule]
})
export class UpdateInvoiceDialogComponent implements OnInit {
  generatingInvoices: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<UpdateInvoiceDialogComponent>,
    public invoiceService: InvoiceService,
    @Inject(MAT_DIALOG_DATA) public data: any
    ) { }

  ngOnInit() {
  }

  generateUpdatedInvoices(): void {
    
    this.generatingInvoices = true;
    this.invoiceService.post([], {}).subscribe(() => {
        this.generatingInvoices = false;
        this.dialogRef.close();
    },() => {
      this.generatingInvoices = false;
      
    });

    
}

}
